import { Store, StoreConfig } from '@bryntum/schedulerpro'
import PlayerModel from '@/components/bryntum/models/PlayerModel'

class PlayerStore extends Store {
  static $name = 'PlayerStore'

  static get defaultConfig(): Partial<StoreConfig> {
    return {
      modelClass: PlayerModel,
      sorters: [
        { field: 'fullName', ascending: true }
      ],
      groupers: [
        { field: 'positionLabel', ascending: true },
      ]
    }
  }
}

export default PlayerStore
